import { useSelector, useDispatch } from 'react-redux'
import _ from '@strings'
import Inner from '@components/Ui/Inner'
import { Sizer } from '@components/Ui/Grid'
import Spacer from '@components/Ui/Spacer'
import ProgressDot from '@components/Ui/ProgressDot'
import { STEP_TYPE, STEP_LOCATION, STEP_DATETIME, STEP_REVIEW, STEP_CONFIRMATION } from '@names'
import { loadStep } from '@store/actions/app'
import styles from './Progress.scss'

const Progress = () => {
  const step = useSelector((s) => s.app.step)
  const dispatch = useDispatch()

  const isActive = (s) => s === step
  const isOneOfSteps = (steps) => steps.indexOf(step) >= 0
  const maybeAllowLoadStep = (s) => {
    if (step !== STEP_CONFIRMATION) {
      dispatch(loadStep(s))
    }
  }

  const getLineFillWidth = () => {
    switch (step) {
      case STEP_LOCATION:
        return 33.3333
      case STEP_DATETIME:
        return 66.6666
      case STEP_REVIEW:
        return 100
      default:
        return 0
    }
  }

  return (
    <Inner className={styles.base}>
      <Sizer
        size="10/12@md 8/12@lg"
        push="1/12@md 2/12@lg"
        pull="1/12@md 2/12@lg"
        className={styles.container}
      >
        <div className={styles.line}>
          <div className={styles.fill} style={{ width: `${getLineFillWidth()}%` }} />
        </div>
        <ProgressDot
          number="1"
          text={_('progress.type')}
          active={isActive(STEP_TYPE)}
          checked={isOneOfSteps([STEP_LOCATION, STEP_DATETIME, STEP_REVIEW, STEP_CONFIRMATION])}
          onClick={() => maybeAllowLoadStep(STEP_TYPE)}
        />
        <ProgressDot
          number="2"
          text={_('progress.location')}
          active={isActive(STEP_LOCATION)}
          checked={isOneOfSteps([STEP_DATETIME, STEP_REVIEW, STEP_CONFIRMATION])}
          onClick={() => maybeAllowLoadStep(STEP_LOCATION)}
        />
        <ProgressDot
          number="3"
          text={_('progress.datetime')}
          active={isActive(STEP_DATETIME)}
          checked={isOneOfSteps([STEP_REVIEW, STEP_CONFIRMATION])}
          onClick={() => maybeAllowLoadStep(STEP_DATETIME)}
        />
        <ProgressDot
          number="4"
          text={_('progress.data')}
          active={isActive(STEP_REVIEW)}
          checked={isOneOfSteps([STEP_CONFIRMATION])}
        />
      </Sizer>
      <Spacer vertical scale="1" />
    </Inner>
  )
}

Progress.defaultProps = {}
Progress.propTypes = {}

export default Progress
